
//load config.json with fetch
module.exports = async function () {
    const configUrl = window.location.origin + '/static/config/config.json'
    const response = await fetch(configUrl)
    return await response.json()
}


//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = 377
// module chunks = 1